module.exports = __webpack_public_path__ + "images/emoji/taurus.3b264b8bb6ae7639f763.png";